import React from 'react';

export function Input({
  label,
  hint,
  error,
  placeholder,
  value,
  defaultValue,
  onChange,
  icon = null,
  type = 'text',
  disabled = false,
  required = false,
  multiline = false,
  rows = 3,
  id,
}) {
  const [focused, setFocused] = React.useState(false);
  const fieldId = id || label?.toLowerCase().replace(/\s+/g, '-');
  const Tag = multiline ? 'textarea' : 'input';
  return (
    <div style={{ display: 'grid', gap: '6px', width: '100%' }}>
      {label && (
        <label htmlFor={fieldId} style={{ fontSize: 'var(--fs-body-sm)', fontWeight: 500, color: 'var(--text-1)' }}>
          {label}{required && <span style={{ color: 'var(--status-danger-text)' }}> *</span>}
        </label>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: multiline ? 'flex-start' : 'center',
          gap: '8px',
          minHeight: multiline ? 'auto' : '40px',
          padding: multiline ? '10px 14px' : '0 14px',
          borderRadius: 'var(--radius-md)',
          border: `1px solid ${error ? 'var(--status-danger-text)' : focused ? 'var(--focus-ring-color)' : 'var(--border-strong)'}`,
          boxShadow: focused ? 'var(--focus-ring-shadow)' : 'none',
          background: disabled ? 'var(--surface-2)' : 'var(--surface-1)',
          transition: 'box-shadow var(--duration-fast) var(--ease-standard), border-color var(--duration-fast) var(--ease-standard)',
        }}
      >
        {icon}
        <Tag
          id={fieldId}
          rows={multiline ? rows : undefined}
          type={multiline ? undefined : type}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          disabled={disabled}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            font: 'inherit',
            color: 'var(--text-1)',
            fontSize: 'var(--fs-body-md)',
            padding: multiline ? 0 : '10px 0',
            resize: multiline ? 'vertical' : 'none',
          }}
        />
      </div>
      {(hint || error) && (
        <span style={{ fontSize: 'var(--fs-caption)', color: error ? 'var(--status-danger-text)' : 'var(--text-muted)' }}>
          {error || hint}
        </span>
      )}
    </div>
  );
}
